var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/multiply/moveMultiplyFromOwn.ts";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";

/* eslint-disable no-await-in-loop */
import * as api from '@gmini/sm-api-sdk';
import { isNotEmpty } from '@gmini/utils';
import { isBimRefType, isGroupType, nodeToApiTypeMap } from "../../../classifier-service/adapters";
//TODO проверить, если не нужно удалить
// export function moveMultiplyFromOwn1({
//   classifierCheckedItems,
//   currentClassifier,
//   nextParentNode,
//   onSuccessItem,
// }: {
//   classifierCheckedItems: readonly CheckedItem[]
//   currentClassifier: { id: number; version: number }
//   nextParentNode: Tree.Node
//   onSuccessItem?: (checkedItem: CheckedItem) => void
// }) {
//   if (
//     nextParentNode.type === 'TreeItemLoadMore' ||
//     nextParentNode.type === 'TreeItemAddNode'
//   ) {
//     return
//   }
//   classifierCheckedItems.reduce(async (versionReqs: any, payload) => {
//     const versions = await versionReqs
//     const result = await (async () => {
//       const node = getNode(input.nodes$.getState(), payload)
//       if (!node) return
//       const lastVersion =
//         versions[versions.length - 1] || currentClassifier.version
//       if (isUserClassifierGroupNode(node)) {
//         if (DropOwnGroupType.is(nextParentNode.node.type)) {
//           const result = await api.UserClassifierGroup.move.defaultContext({
//             classifierId: currentClassifier.id,
//             parentClassifierVersion: lastVersion,
//             id: node.id,
//             parentGroupId:
//               nextParentNode.node.id !== currentClassifier.id
//                 ? Number(nextParentNode.node.id)
//                 : null,
//           })
//           onSuccessItem && onSuccessItem(payload)
//           return result.parentClassifierVersion
//         }
//       } else if (isBimNode(node) || isReferenceNode(node)) {
//         if (DropOwnElementType.is(nextParentNode.node.type)) {
//           const nodes = input.nodes$.getState().ReferenceNode
//           const reference = getCheckedElementRef({
//             node,
//             nodes,
//             checkedItem: payload,
//           })
//           const directRef = reference
//             ? buildNodeKey(reference.element) === buildNodeKey(node)
//             : false
//           if (reference && directRef) {
//             const res = await api.BimReference.move.defaultContext({
//               classifierId: currentClassifier.id,
//               classifierVersion: lastVersion,
//               id: reference.id,
//               groupId: Number(nextParentNode.node.id),
//             })
//             onSuccessItem && onSuccessItem(payload)
//             return res.parentClassifierVersion
//           }
//         }
//       }
//     })()
//     return [...versions, result]
//   }, Promise.resolve([]))
// }
export function moveMultiplyFromOwn(_ref) {
  var items = _ref.items,
      currentClassifier = _ref.currentClassifier,
      target = _ref.target,
      nodes$ = _ref.nodes$;
  var modelRefItems = items.map(function (_ref2) {
    var type = _ref2.type,
        id = _ref2.id;
    return isBimRefType(type) ? {
      id: id,
      type: nodeToApiTypeMap[type]
    } : null;
  }).filter(isNotEmpty);

  if (modelRefItems.length) {
    api.BimReference.moveRefs.defaultContext({
      parentGroupId: target ? target.id : null,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      items: modelRefItems,
      id: currentClassifier.id,
      version: currentClassifier.version
    });
  }

  var groupItems = items.map(function (_ref3) {
    var type = _ref3.type,
        id = _ref3.id;
    return isGroupType(type) ? {
      id: id,
      type: nodeToApiTypeMap[type]
    } : null;
  }).filter(isNotEmpty);

  if (groupItems.length) {
    var parentGroupId = target.type === 'UserClassifierNode' ? null : target.id;
    api.BimReference.moveRefs.defaultContext({
      parentGroupId: parentGroupId,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      items: groupItems,
      id: currentClassifier.id,
      version: currentClassifier.version
    });
  } //TODO проверить, если не нужно удалить
  // const leftItems = [...items]
  // let lastVersion = currentClassifier.version
  // while (leftItems.length > 0) {
  //   const itemRef = leftItems.shift()!
  //   const node = getNode(nodes$.getState(), itemRef)!
  //   if (isUserClassifierGroupNode(node)) {
  //     const result = await api.UserClassifierGroup.move.defaultContext({
  //       classifierId: currentClassifier.id,
  //       parentClassifierVersion: lastVersion,
  //       id: node.id,
  //       parentGroupId: target ? target.id : null,
  //     })
  //     lastVersion = result.parentClassifierVersion
  //   } else if (isReferenceNode(node)) {
  //     if (!target) {
  //       throw new Error('Could not move reference into root level')
  //     }
  //     const res = await api.BimReference.move.defaultContext({
  //       classifierId: currentClassifier.id,
  //       classifierVersion: lastVersion,
  //       id: node.id,
  //       groupId: target.id,
  //     })
  //     lastVersion = res.parentClassifierVersion
  //   }
  // }

}